
define(
	'Tavanoteam.HazardousProducts.AddHazmatFee'
	, [
		'Tavanoteam.HazardousProducts.AddHazmatFee.View'
		, 'jQuery'
		, 'underscore'
		, 'Utils'
	]
	, function (
		AddHazmatFeeView
		, $
		, _
		, Utils
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {

				var self = this;

				this.cartComponent = container.getComponent('Cart');
				this.environmentComponent = container.getComponent('Environment');
				this.checkoutComponent = container.getComponent('Checkout');

				this.checkIfHazardous();

			}

			//Check if the item added to the cart is hazardous
			, checkIfHazardous: function () {

				var self = this;

				//Get Pickup Ship Method ID
				var pickupShipMethodId = this.environmentComponent.getConfig('ttPickupInStore.pickupShipMethodId');

				// Check if is in Checkout Page
				var isCheckout = Utils.isInCheckout();

				// Before Adding Line
				/** This is the original event for adding the hazardous item to the cart.
				 * Retaining this event for future reference to avoid breaking changes.
				*/
				// this.cartComponent.cancelableOn('beforeAddLine', function (data) {

				// 	var itemSearchUrl = self.buildSearchUrl(data);

				// 	$.ajax(itemSearchUrl).then(function (data) {
				// 		var item = data.items[0];
				// 		var isHazardous = item.custitemcustitem_is_hazardous;

				// 		if (isHazardous) {
				// 			self.checkHazardItemCount(false);
				// 		}
				// 	});
				// });

				// After Adding Line
				this.cartComponent.cancelableOn('afterAddLine', function (data) {

					var itemSearchUrl = self.buildSearchUrl(data);

					$.ajax(itemSearchUrl).then(function (data) {
						var item = data.items[0];
						var isHazardous = item.custitemcustitem_is_hazardous;

						if (isHazardous) {
							self.checkHazardItemCount(false);
						}
					});
				});				

				// After Updating Line
				this.cartComponent.cancelableOn('afterUpdateLine', function (data) {

					var itemSearchUrl = self.buildSearchUrl(data);

					$.ajax(itemSearchUrl).then(function (data) {
						var item = data.items[0];
						var isHazardousFee = item.internalid == 14490 ? true : false;

						if (isHazardousFee) {
							self.checkHazardItemCount(false);
						}
					});
					
				});

				// If Page is not Checkout
				if (!isCheckout) {

					// After Removing Line
					this.cartComponent.cancelableOn('afterRemoveLine', function (data) {

						var lineId = data.line_id,
							itemSubstringIndex = 4;

						var itemId = lineId.substring(
							itemSubstringIndex,
							lineId.lastIndexOf("set")
						);

						var itemSearchUrl = self.buildSearchUrl(itemId);

						$.ajax(itemSearchUrl).then(function (data) {
							var item = data.items[0];
							var isHazardous = item.custitemcustitem_is_hazardous;
							var isHazardousFee = item.internalid == 14490 ? true : false;

							if (isHazardous || isHazardousFee) {
								self.checkHazardItemCount(false);
							}
						});
					});

				}

				// If Page is Checkout and Pickup Shipping is Available
				if (isCheckout && pickupShipMethodId) {

					// After Shipping Method Change
					this.cartComponent.cancelableOn('afterSetShipMethod', function (data) {

						var shipmethod = data;

						if (shipmethod.internalid == pickupShipMethodId) {
							//If Shipping Method is Pickup
							self.checkHazardItemCount(true);
						} else {
							//If Shipping Method is Not Pickup
							self.checkHazardItemCount(false);
						}
						
					});
				
					// Get Shipping Method
					this.cartComponent.getShipMethod().then(function(shipmethod) {
						if (shipmethod.internalid == pickupShipMethodId) {
							//If Shipping Method is Pickup
							self.checkHazardItemCount(true);
						} else {
							//If Shipping Method is Not Pickup
							self.checkHazardItemCount(false);
						}
					});

				} else {
					
					// Execute Logic for Shopping Pages
					this.checkHazardItemCount(false);

				}

			}


			//Build the item search api url. returns the full url
			, buildSearchUrl: function (data) {
				var domain = this.environmentComponent.getSiteSetting('touchpoints.home');

				var itemId = data.line ? data.line.item.internalid : data,
					itemQueryUrl = '?id=' + itemId + '&fieldset=details',
					itemSearchUrl = domain + '/api/items' + itemQueryUrl;

				return itemSearchUrl;
			}

			//Check if ther count hazardous items. Hazard fee should match the quantity of hazardous items
			, checkHazardItemCount: function (isPickup) {

				var self = this;
				var hazardousItemCount = 0,
					hazardousFeeCount = 0,
					hazmatFeeQuantity = 0;				

				this.cartComponent.getLines().then(function (lines) {
					//Check the number of lines in the cart for hazardous items and its respective fee
					_.each(lines, function (line) {
						var item = line.item,
							quantity = line.quantity,
							isHazardous = item.extras.custitemcustitem_is_hazardous,
							isHazardousFee = item.internalid == 14490 ? true : false;

						if (isHazardous) {
							hazardousItemCount++;
						}

						if (isHazardousFee) {
							hazardousFeeCount++;
							hazmatFeeQuantity = quantity;
						}
					});			

					if (hazardousFeeCount > 0) {						

						//Find Hazmat Fee Item Line ID
						var hazmatFeeItemId = 14490,
							hazmatFeeCartIndex = _.findIndex(lines, function (line) {
								return line.item.internalid == hazmatFeeItemId
							}),
							lineItemId = lines[hazmatFeeCartIndex].internalid;

					}
					
					if (isPickup) {
						
						//Remove Hazmat Fee if Shipping Method is Pickup
						self.removeHazmatFee(lineItemId);

					} else {

						if (hazardousItemCount < hazmatFeeQuantity) {
							if (hazardousItemCount == 0) {
								self.removeHazmatFee(lineItemId);
							} else {
								self.updateHazmatFee(lineItemId, hazardousItemCount);
							}
						}
						 
						if (hazardousItemCount > hazmatFeeQuantity) {
							self.updateHazmatFee(lineItemId, hazardousItemCount);
						}
					    
						if (hazardousItemCount > 0 && hazardousFeeCount == 0) {
							self.addHazmatFee(hazardousItemCount);
						}

					}

				});
			}

			//Add the quantity of the hazmat fee in the cart
			, addHazmatFee: function (quantity) {

				if (this.cartComponent) {
					this.cartComponent.addLine({
						line: {
							quantity: quantity,
							item: {
								internalid: 14490
							}
						}
					})
				}
			}

			//Update the quantity of the hazmat fee in the cart
			, updateHazmatFee: function (itemId, quantity) {

				if (this.cartComponent) {
					this.cartComponent.updateLine({
						line: {
							internalid: itemId,
							quantity: quantity
						}
					}).then(function () {
						return;
					});
				}
			}

			//Remove hazmat fee if there is no hazardous items in the cart
			, removeHazmatFee: function (itemId) {

				if (this.cartComponent) {
					this.cartComponent.removeLine({
						line_id: itemId
					}).then(function () {
						return;
					});
				}
			}

		};
	});
